import React from 'react';

import ButtonLink from '../buttons/btn-link';

interface ErrorMessageProps {
  errorCode: string;
  title: string;
  description: string;
  redirectTo?: string;
}

const ErrorMessage = ({
  errorCode,
  title,
  description,
  redirectTo = '/',
}: ErrorMessageProps) => {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-gray-100">
      <div className="container flex flex-col items-center justify-center px-5 text-gray-700 md:flex-row">
        <div className="max-w-md text-center">
          <div className="text-5xl font-bold">{errorCode}</div>
          <p className="text-2xl font-light leading-normal md:text-3xl">
            {title}
          </p>
          <p className="mb-8">{description}</p>

          <div className="m-auto w-44">
            <ButtonLink
              link={redirectTo}
              label={'Back to home'}
              isOpenNewTab={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;
